import React from 'react';
import './Comitecdq.css';

const Textebon = ({ children }) => {
  return (

    <div className='boss-comite1'>
    <h4 className='enfant-text-comite1'>COMITE DE DEVELOPPEMENT DES QUARTIERS (CDQ) DU 2eme ARRONDISSEMENT DE PORT-GENTIL</h4> 
    <div className='texte-comite'>
      <p>
      Le Comité de Développement des Quartiers (CDQ) est
      un acteur clé dans l'amélioration du cadre de vie de nos quartiers. Chaque CDQ, propre à chaque quartier,travaille en étroite collaboration avec le Chef du dit quartier.
      Les CDQ, ce sont avant tout des citoyens engagés qui donnent de leur temps pour améliorer leur quartier. 
      Leur action est essentielle, mais elle ne peut se faire sans vous. En rejoignant votre CDQ, vous pourrez 
      contribuer activement à façonner votre environnement et à créer un quartier où il fait bon vivre.
      </p>
    </div>
    </div>   
   
  );
};

export default Textebon ;
